export const SET_CARDS = "cards.SET_CARDS";
export const CLEAR_CARDS = "cards.CLEAR_CARDS";
export const SET_CARD_IMAGES = "cards.SET_CARD_IMAGES";
export const TOGGLE_DISPLAY = "cards.TOGGLE_DISPLAY";
export const SET_DISPLAY_IMAGE = "cards.SET_DISPLAY_IMAGE";
export const CLOSE_IMAGE = "cards.CLOSE_IMAGE";
export const OPEN_IMAGE = "cards.OPEN_IMAGE";
export const SET_ERROR = "cards.SET_ERROR";
